import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { apiLogin, auth } from "../lib/api";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error("Enter both username and password");
      return;
    }
    setLoading(true);
    try {
      const res = await apiLogin(username.trim(), password.trim());
      auth.save(res.token, { username: res.username, title: res.title });
      toast.success(`Welcome, ${res.username}`);
      navigate("/", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center p-6">
      <form
        onSubmit={handleSubmit}
        data-testid="login-form"
        className="bg-[#FFFCF5] p-8 md:p-12 border border-[#E6E2D8] shadow-sm rounded-lg max-w-md w-full flex flex-col gap-6"
      >
        <div className="flex items-center gap-3">
          <img
            src="/logo.png.PNG"
            alt="Beirut Bites Logo"
            className="h-12 w-12 rounded-lg object-contain"
          />
          <div>
            <h1 className="font-heading text-2xl font-black tracking-tight text-[#1A1918] leading-none">
              Beirut Bites
            </h1>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#5C5854] mt-1">
              Sales Console
            </p>
          </div>
        </div>

        <div className="h-px bg-[#E6E2D8]" />

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="username" className="text-xs font-bold uppercase tracking-[0.15em] text-[#5C5854]">
              Username
            </Label>
            <Input
              id="username"
              data-testid="login-username-input"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="bg-white border-[#E6E2D8] focus-visible:ring-[#C84C31]/30 focus-visible:border-[#C84C31] h-12 text-base"
            />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="password" className="text-xs font-bold uppercase tracking-[0.15em] text-[#5C5854]">
              Password
            </Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white border-[#E6E2D8] focus-visible:ring-[#C84C31]/30 focus-visible:border-[#C84C31] h-12 text-base"
            />
          </div>
        </div>

        <Button
          type="submit"
          data-testid="login-submit-button"
          disabled={loading}
          className="bg-[#C84C31] hover:bg-[#A83C25] text-white font-bold h-12 text-base rounded-lg"
        >
          {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign in"}
        </Button>

        <p className="text-xs text-[#5C5854] text-center">
          Credentials are managed in the company Google Sheet.
        </p>
      </form>
    </div>
  );
}
